import { createWeb3Modal, defaultWagmiConfig } from "@web3modal/wagmi"

import { mainnet, /*polygon, */bsc, /*base*/ } from "viem/chains"
import { GetAccountReturnType, getAccount, getBalance, switchChain, watchAccount, writeContract } from "@wagmi/core"
import { erc20Abi, formatEther, parseEther } from "viem"
import axios from "axios"
import { createError, getErrorMessage } from "./helpers"

export type AccountStatus = "connected" | "connecting" | "disconnected" | "reconnecting"
export type Token = "usdc" | "usdt"
export type Chain =
| "erc20"
// | "polygon"
| "bep20"
// | "base"

const projectId = "ac9c157eec5d890ad7dc1cd70a007394"

const metadata = {
  name: "Tip the Winner",
  description: "Tip the winner of the next game!",
  url: "https://web3modal.com", // origin must match your domain & subdomain.
  icons: ["https://avatars.githubusercontent.com/u/37784886"]
}

const chains = [
  mainnet,
  // polygon,
  bsc,
  // base
] as const
const chainsMap = {
  erc20: mainnet,
  // polygon,
  bep20: bsc,
  // base
}
const chainsLabels = {
  erc20: "Ethereum (ERC20)",
  // polygon: "Polygon",
  bep20: "Binance chain (BEP20)",
  // base: "Base"
}

const tokenAddresses: {
  [key in Token]: {
    [key in Chain]: `0x${string}`
  }
} = {
  usdc: {
    erc20: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
    // polygon: "0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359",
    bep20: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
    // base: "0x4f96fe3b7a6cf9725f59d353f723c1bdb64ca6aa"
  },
  usdt: {
    erc20: "0xdac17f958d2ee523a2206206994597c13d831ec7",
    // polygon: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
    bep20: "0x55d398326f99059ff775485246999027b3197955",
    // base: "0x55d398326f99059ff775485246999027b3197955"
  }
}

const config = defaultWagmiConfig({
  chains,
  projectId,
  metadata,
})

export const initTipView = (gameId: string, userId: string, address: `0x${string}`) => {
  window.tipData = {
    accountStatus: "disconnected",
    gameId,
    userId,
    receiverAddress: address,
    token: "usdt",
    chain: "erc20",
    tipAmount: 5
  }
  window.web3Modal = createWeb3Modal({
    wagmiConfig: config,
    projectId,
  })
  watchWallet()
}

export const onTokenSubmit = (event: SubmitEvent) => {
  event.preventDefault()
  const form = event.target as HTMLFormElement
  const formData = new FormData(form)
  const token = formData.get("token") as Token

  if (token) {
    form.style.display = "none"
    window.tipData.token = token

    const tokenInfo = document.getElementById("token-info")!
    const tokenValue = tokenInfo.querySelector("[data-value]")! as HTMLElement
    tokenValue.innerText = token
    tokenInfo.style.display = "block"

    const chainForm = document.getElementById("chain-form")!
    chainForm.style.display = "block"
  }
}

export const onChainBack = () => {
  const tokenForm = document.getElementById("token-form")!
  tokenForm.style.display = "block"
  const tokenInfo = document.getElementById("token-info")!
  tokenInfo.style.display = "none"
  const chainForm = document.getElementById("chain-form")!
  chainForm.style.display = "none"
}

export const onChainSubmit = (event: SubmitEvent) => {
  event.preventDefault()
  const form = event.target as HTMLFormElement
  const formData = new FormData(form)
  const chain = formData.get("chain") as Chain

  if (chain) {
    form.style.display = "none"
    window.tipData.chain = chain

    const chainInfo = document.getElementById("chain-info")!
    const chainValue = chainInfo.querySelector("[data-value]")! as HTMLElement
    chainValue.innerText = chainsLabels[chain]
    chainInfo.style.display = "block"

    const tipAmountForm = document.getElementById("tip-amount-form")!
    tipAmountForm.style.display = "block"
  }
}

export const onTipAmountBack = () => {
  const chainForm = document.getElementById("chain-form")!
  chainForm.style.display = "block"
  const chainInfo = document.getElementById("chain-info")!
  chainInfo.style.display = "none"
  const tipAmountForm = document.getElementById("tip-amount-form")!
  tipAmountForm.style.display = "none"
}

export const onTipAmountSubmit = (event: SubmitEvent) => {
  event.preventDefault()
  const form = event.target as HTMLFormElement
  const formData = new FormData(form)
  const tipAmountValue = formData.get("tipAmount") as string
  const tipAmount = Number(tipAmountValue)
  console.log(tipAmount)
  if (tipAmount) {
    // form.style.display = "none"
    window.tipData.tipAmount = tipAmount
    console.log(window.tipData)
    connect()
  }
}

async function connect() {
  const account = getAccount(config)
  if (account.isConnected) {
    if (await checkChain(account)) {
      if (await checkBalance(account)) {
        sendTransaction(account)
        return
      }

      createError("Your balance is not enough")
    }

    await requestSwitchChain(async() => {
      if (await checkBalance(account)) {
        sendTransaction(account)
        return
      }

      createError("Your balance is not enough")
    })
  } else {
    window.web3Modal?.open()
  }
}

const sendTransaction = async(account: GetAccountReturnType) => {
  try {
    const {
      gameId,
      userId,
      chain,
      token,
      tipAmount,
      receiverAddress
    } = window.tipData

    const result = await writeContract(config, {
      abi: erc20Abi,
      address: tokenAddresses[token][chain],
      chainId: account.chainId,
      functionName: "transfer",
      args: [receiverAddress, parseEther(`${tipAmount}`)],
    })

    if (result) {
      try {
        await axios.post("/tip", {
          gameId,
          userId,
          tipAmount,
          chain,
          token,
          addressFrom: account.address,
          addressTo: receiverAddress
        })

        showSuccessMessage()
      } catch (e) {
        const err = getErrorMessage(e)
        console.warn(err)
        createError(err)
      }
    } else {
      throw new Error("Unexpected error")
    }
  } catch (e) {
    console.warn(e)
    createError(e)
  }
}

const checkChain = async(account: GetAccountReturnType) => {
  if (account.isConnected) {
    const { chain } = window.tipData
    return account.chainId === chainsMap[chain].id
  }

  return false
}

const requestSwitchChain = async(onSwitch?: () => void) => {
  try {
    await switchChain(config, {
      chainId: chainsMap[window.tipData.chain].id
    })
    onSwitch?.()
  } catch (e) {
    console.warn(e)
    createError("You must switch chain to proceed")
  }
}

const checkBalance = async(account: GetAccountReturnType) => {
  if (account.isConnected && account.address) {
    console.log("checking balance for account", account.address)

    const {
      chain,
      token,
      tipAmount
    } = window.tipData

    const balance = await getBalance(config, {
      address: account.address,
      chainId: account.chainId,
      token: tokenAddresses[token][chain]
    })
    const tokenBalance = parseFloat(formatEther(balance.value))
    console.log("balance", balance)

    return tokenBalance >= tipAmount
  }
}

const setAccountStatus = (account: GetAccountReturnType): void => {
  window.tipData.accountStatus = account.status
}

const watchWallet = () => {
  watchAccount(config, {
    async onChange(account) {
      console.log("account: onChange", account)
      console.log("previous status", window.tipData.accountStatus)

      if (account.isConnected && window.tipData.accountStatus !== "connected" && account.address) {
        if (await checkChain(account)) {
          if (await checkBalance(account)) {
            sendTransaction(account)
          } else {
            createError("Your token balance is not enough")
          }
        } else {
          await requestSwitchChain(async() => {
            if (await checkBalance(account)) {
              sendTransaction(account)
            } else {
              createError("Your balance is not enough")
            }
          })
        }
      }

      setAccountStatus(account)
    }
  })
}

const showSuccessMessage = () => {
  window.open("/tip-success", "_self")
}
